<template>
  <div v-if="briefInfo?.title" class="new-ticket" @click="toggleNotice()">
    <div class="new-ticket-top">
      <img class="tooltip-btn-icon" src="@/assets/images/ticket.webp" alt="ticket" />
      <div class="new-ticket-num">
        想要:
        <span class="new-ticket-num-unit">{{ getTicketNum(Number(ticketStore.getTicket)) }}</span>
        <span
          v-if="briefInfo?.tip && !route.query.openWantLayer"
          class="new-ticket-tag"
          :class="{ active: Number(ticketStore.getTicket) > 99 }"
          v-html="briefInfo?.tip"
        ></span>
      </div>
      <svg
        class="new-ticket-arrow"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M4.39645 1.39645C4.20118 1.59171 4.20118 1.90829 4.39645 2.10355L8.29289 6L4.39645 9.89645C4.20118 10.0917 4.20118 10.4083 4.39645 10.6036C4.59171 10.7988 4.90829 10.7988 5.10355 10.6036L9.35355 6.35355C9.54882 6.15829 9.54882 5.84171 9.35355 5.64645L5.10355 1.39645C4.90829 1.20118 4.59171 1.20118 4.39645 1.39645Z"
          fill="#101010"
          stroke="#101001"
          stroke-width="0.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="new-ticket-bottom">
      <span class="new-ticket-bottom-title">
        <img class="new-ticket-bottom-title-icon" src="./images/gift.png" alt="gift" />
        <span class="new-ticket-bottom-title-text">{{ briefInfo.title }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
          <path
            d="M0.123169 7.87668C-0.0412617 7.71225 -0.0412617 7.44565 0.123169 7.28122L3.40439 4L0.123169 0.718782C-0.0412617 0.55435 -0.0412617 0.287755 0.123169 0.123323C0.287601 -0.0411081 0.554197 -0.0411081 0.718628 0.123323L4.29757 3.70227C4.46201 3.8667 4.46201 4.1333 4.29757 4.29773L0.718628 7.87668C0.554197 8.04111 0.287601 8.04111 0.123169 7.87668Z"
            fill="#101010"
          />
        </svg>
      </span>
      <span class="new-ticket-bottom-desc" v-html="briefInfo.content"></span>
    </div>
    <div v-if="briefInfo.bubble" class="tooltip-layer">
      <span v-html="formatCondition(briefInfo.bubble)"></span>
      <div @click.stop="closeBriefInfo" class="tooltip-layer-close-btn">我知道了</div>
      <!-- <img class="tooltip-layer-delete" src="./images/delete.png" alt="delete" /> -->
    </div>
  </div>

  <AppReceive
    v-if="showClaimRewards"
    :taskId="taskId"
    @closeClaimRewards="closeClaimRewards"
    @goVoteWantIt="goVoteWantIt"
  />

  <div class="notice-overlay" v-if="showTicket" @click="closeNotice">
    <div @click.stop class="notice-lists">
      <div class="notice-nav">
        <div
          :class="{ 'notice-nav-item-active': navType === 'makeReal' }"
          class="notice-nav-item"
          @click="navHandle('makeReal')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clip-path="url(#clip0_988_30694)">
              <path
                d="M12.2761 12.2345V6.39258H1.72461V12.2345C1.72461 12.7868 2.17233 13.2345 2.72461 13.2345H11.2761C11.8284 13.2345 12.2761 12.7868 12.2761 12.2345Z"
                :stroke="navType === 'makeReal' ? '#ffffff' : '#101010'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 13.2344V6.39062"
                :stroke="navType === 'makeReal' ? '#ffffff' : '#101010'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.1381 4.79199V5.3928C13.1381 5.94508 12.6904 6.3928 12.1381 6.3928H1.8623C1.31002 6.3928 0.862305 5.94508 0.862305 5.3928V4.79199C0.862305 4.23971 1.31002 3.79199 1.8623 3.79199H12.1381C12.6904 3.79199 13.1381 4.23971 13.1381 4.79199Z"
                :stroke="navType === 'makeReal' ? '#ffffff' : '#101010'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99995 3.79167C6.99995 2.91667 5.97912 0.875 4.44787 0.875C1.95676 0.875 2.86421 3.79167 4.05652 3.79167"
                :stroke="navType === 'makeReal' ? '#ffffff' : '#101010'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 3.79167C7 2.91667 8.02083 0.875 9.55208 0.875C12.0432 0.875 11.1357 3.79167 9.94343 3.79167"
                :stroke="navType === 'makeReal' ? '#ffffff' : '#101010'"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_988_30694">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>玩「想要」解锁平台奖励</span>
        </div>
        <div
          :class="{ 'notice-nav-item-active': navType === 'ticketDetail' }"
          class="notice-nav-item"
          @click="navHandle('ticketDetail')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M8.5 0.5H5.5C4.94772 0.5 4.5 0.947715 4.5 1.5V2C4.5 2.55228 4.94772 3 5.5 3H8.5C9.05228 3 9.5 2.55228 9.5 2V1.5C9.5 0.947715 9.05228 0.5 8.5 0.5Z"
              :stroke="navType === 'ticketDetail' ? '#ffffff' : '#101010'"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.75 1.5H11.25C11.5152 1.5 11.7696 1.60536 11.9571 1.79289C12.1446 1.98043 12.25 2.23478 12.25 2.5V12.5C12.25 12.7652 12.1446 13.0196 11.9571 13.2071C11.7696 13.3946 11.5152 13.5 11.25 13.5H2.75C2.48478 13.5 2.23043 13.3946 2.04289 13.2071C1.85536 13.0196 1.75 12.7652 1.75 12.5V2.5C1.75 2.23478 1.85536 1.98043 2.04289 1.79289C2.23043 1.60536 2.48478 1.5 2.75 1.5H4.25"
              :stroke="navType === 'ticketDetail' ? '#ffffff' : '#101010'"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 6.75H9"
              :stroke="navType === 'ticketDetail' ? '#ffffff' : '#101010'"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 8.75H9"
              :stroke="navType === 'ticketDetail' ? '#ffffff' : '#101010'"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>想要次数明细</span>
        </div>
      </div>
      <h4 v-show="navType === 'ticketDetail'" class="notice-title">
        <span class="text1">{{ ticketStore.getTicket }} 张</span>
        <span class="text2">{{ $t('appTicket.refresh_info') }}</span>
        <!-- <span class="notice-title-icon" to="/make-real" @click="handleToMakeReal">?</span> -->
      </h4>
      <div v-show="navType === 'ticketDetail'" class="notice-lists-box">
        <div class="notice-lists-item" v-if="loading">
          <AppLoading />
        </div>
        <div class="notice-no-data" v-if="!loading && historyList.length === 0">
          <img src="@/assets/images/notice-no-data.webp" width="48" />
          <p>{{ $t('appTicket.no_message') }}</p>
        </div>
        <div v-for="item in historyList" :key="item.uniqueTicketLogId" class="notice-lists-item">
          <div class="notice-content">
            <p class="notice-user-name">{{ item.title }}</p>
            <p class="notice-user-msg">{{ formatDateTime24Hour(item.createTime) }}</p>
          </div>
          <div class="notice-count" :class="{ get: item.type === 1, send: item.type === 2 }">
            {{ item.type === 1 ? '+' : '' }}{{ item.nums }}
          </div>
        </div>
      </div>
      <AppTicketWanted
        v-show="navType === 'makeReal'"
        @openClaimHistory="openClaimHistory"
        @closeLayer="closeNotice"
        @openClaimRewards="openClaimRewards"
        @goVoteWantIt="goVoteWantIt"
        @wantedDataLoaded="handleWantedDataLoaded"
      />
    </div>
    <AppClaimHistory v-if="showClaimHistory" @closeClaimHistory="closeClaimHistory" />
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch, onMounted, watchEffect, computed, nextTick } from 'vue'
  import { useTicketStore } from '@common/stores/userTicket'
  import _fetch from '@/utils/fetch'
  import AppLoading from '@components/components/AppLoading/AppLoading.vue'
  import { eventBus } from '@common/utils/eventBus'
  import { useRouter } from 'vue-router'
  import AppTicketWanted from './components/wanted/index.vue'
  import AppReceive from './components/receive/index.vue'
  import AppClaimHistory from './components/claim-history/index.vue'
  import { useRoute } from 'vue-router'
  import trackEvent from '@common/track/trackEvent'
  import LoginService from '@common/components/AppLogin/login'
  import { useUserStore } from '@common/stores/userStore'
  import { useNavigate } from '../../../../hooks/useNavigate'
  const userStore = useUserStore()
  const isLogin = computed(() => userStore.isLogin)
  const { navigateTo } = useNavigate()

  defineOptions({
    name: 'AppTicket'
  })

  interface Ticket {
    uniqueTicketLogId: string
    createTime: string
    title: string
    nums: number
    type: number
    [key: string]: any
  }

  const showTicket = ref(false)
  const router = useRouter()
  const ticketStore = useTicketStore()
  const navType = ref('makeReal')
  const route = useRoute()
  const showClaimRewards = ref(false)
  const taskId = ref<string>('')
  const navHandle = (type: string) => {
    navType.value = type
  }

  const getTicketNum = (num: number) => {
    if (!num && num !== 0) {
      return '-'
    }
    return num
  }

  const toggleNotice = async (isOpenWantLayer?: boolean) => {
    if (!isLogin.value) {
      handleLogin()
      return
    }
    if (typeof isOpenWantLayer === 'boolean') {
      showTicket.value = isOpenWantLayer
    } else {
      showTicket.value = !showTicket.value
    }
    navType.value = 'makeReal'

    if (showTicket.value) {
      getHistory()
      const wantEnterFrom = route.query.wantEnterFrom
      trackEvent.track('enter_want_task_page', {
        enter_from: wantEnterFrom || 'homepage'
      })
    } else {
      console.log('closeNotice')
      clearQuery()
      initBriefInfo()
    }
    if (showClaimRewards.value) {
      showClaimRewards.value = false
      showTicket.value = true
      taskId.value = ''
    }
    showClaimHistory.value = false
    eventBus.trigger('closeNotice')
  }

  // 监听 wanted 组件数据加载完成事件
  const handleWantedDataLoaded = () => {
    initBriefInfo()
  }

  const closeNotice = () => {
    showTicket.value = false
    showClaimRewards.value = false
    taskId.value = ''
    clearQuery()
    initBriefInfo()
  }

  const historyList = ref<Ticket[]>([])
  const loading = ref(false)
  const getHistory = async () => {
    loading.value = true
    historyList.value = []
    const response = await _fetch('/aigc/api/ticket/log', {
      method: 'GET',
      params: {
        page: 1,
        pageSize: 1000
      }
    })
    loading.value = false
    const res = await response.json()
    if (res.code === 200) {
      historyList.value = res.data.dataList
    }
  }

  import wantIconSrc from '@/assets/images/ticket.webp'

  const WANT_ICON_HTML = `<img class="want-icon" src="${wantIconSrc}" alt="想要" />`

  const formatCondition = (condition?: string) => {
    if (!condition) {
      return ''
    }
    return condition.split('{want_icon}').join(WANT_ICON_HTML)
  }

  function formatDateTime24Hour(input: string): string {
    if (!input) return ''
    const date = new Date(input)
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    // 格式化日期为 mm/dd/yyyy
    const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`
    // 格式化时间为 24 小时制
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${formattedDate}`
    return formattedTime
  }

  watch(
    () => ticketStore.getSSETicketNum,
    () => {
      setTimeout(() => {
        ticketStore.clearSSETicket()
      }, 7000)
    }
  )
  const pendingOpenWantLayer = ref(false)

  const handleRouteOpenLayer = () => {
    const rawValue = route.query.openWantLayer
    const openWantLayer = Array.isArray(rawValue) ? rawValue[0] : rawValue
    // 3: 打开想要任务页面
    if (openWantLayer === '3') {
      if (!isLogin.value) {
        pendingOpenWantLayer.value = true
        return
      }
      pendingOpenWantLayer.value = false
      nextTick(() => {
        toggleNotice(true)
      })
      return
    }
    // 4: 打开领取奖励页面
    if (openWantLayer === '4') {
      pendingOpenWantLayer.value = false
      showClaimRewards.value = true
      return
    }

    pendingOpenWantLayer.value = false
  }

  watch(
    () => route.query.openWantLayer,
    () => {
      handleRouteOpenLayer()
    },
    { immediate: true }
  )

  watch(
    () => isLogin.value,
    value => {
      if (value && pendingOpenWantLayer.value) {
        handleRouteOpenLayer()
      }
    }
  )

  const showClaimHistory = ref(false)
  const openClaimHistory = () => {
    showClaimHistory.value = true
  }

  const closeClaimHistory = () => {
    showClaimHistory.value = false
  }

  const openClaimRewards = (id: string) => {
    showClaimRewards.value = true
    taskId.value = id
    trackEvent.track('enter_want_award_page')
    console.log('taskId', id)
  }

  const clearQuery = () => {
    const newQuery = { ...route.query }
    ;['openWantLayer', 'wantTaskId', 'wantEnterFrom'].forEach(key => {
      delete newQuery[key]
    })
    router.replace({
      query: newQuery
    })
  }

  const closeClaimRewards = () => {
    showClaimRewards.value = false
    clearQuery()
    initBriefInfo()
  }

  const goVoteWantIt = () => {
    closeNotice()
    navigateTo('https://zaohaowu.com/?activeTabName=want')
  }

  const login = (callback?: () => void) => {
    LoginService({
      type: 'login',
      onSuccess() {
        callback?.()
      }
    })
  }

  const handleLogin = () => {
    login(() => {
      window.location.href = '/'
      initBriefInfo()
    })
  }

  const briefInfo = ref({
    title: '',
    content: '',
    bubble: '',
    tip: ''
  })
  const initBriefInfo = async () => {
    const response = await _fetch('/aigc/api/activity/brief', {
      method: 'GET',
      params: {}
    })
    const res = await response.json()
    console.log('briefInfo', res)
    if (res.code === 200) {
      briefInfo.value = res.data
      // briefInfo.value.tip = '奖励+7'
      // briefInfo.value.bubble = '想要想要想要想要想要想要{want_icon}想要'
    }
  }

  const closeBriefInfo = () => {
    briefInfo.value = {
      ...briefInfo.value,
      bubble: ''
    }
  }

  onMounted(() => {
    initBriefInfo()
    eventBus.addEvent('closeTicketDrawer', () => {
      showClaimRewards.value = false
      showTicket.value = false
    })
    // 注册全局刷新 briefInfo 的事件
    eventBus.addEvent('refreshBriefInfo', () => {
      initBriefInfo()
    })
  })

  // 暴露方法给父组件
  defineExpose({
    closeClaimRewards
  })
</script>

<style lang="stylus" scoped>
  @import './index.styl';
</style>
